const formImage = {
  update: (field, appData) => {
    const value = formImage.extractFieldValue(field, appData.values);
    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    const fieldObject = {
      fieldName: field.name,
      isValid: formImage.validate(field, value),
      isRequired: true,
      errorMessage: appData.settings.translations.please_upload_photo,
      value,
      title: field.title
    };
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  },

  extractFieldValue: (field, values) => {
    const name = field.name.split(":")[0];
    return values[`${name}:photoPreview`];
  },

  validate: (field, value) => {
    return !!value?.file || value?.uuid?.includes("member_attachment");
  }
};

export default formImage;
